import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Contact } from '../models/contact/contact';
import { ContactFilter } from '../models/filters/contact-filter';
import { PartialResult } from '../models/generics/PartialResult';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private httpClient = inject(HttpClient);
  private controllerUrl = environment.apiBaseUrl + '/api/' + environment.apiVersion + '/contact';

  getContacts(): Observable<PartialResult<Contact>> {
    return this.httpClient.get<PartialResult<Contact>>(this.controllerUrl);
  }
  getFilteredContacts(filter: ContactFilter): Observable<PartialResult<Contact>> {
    return this.httpClient.get<PartialResult<Contact>>(this.controllerUrl, {
      params: {
        Offset: filter.offset?.toString(),
        Amount: filter.amount?.toString(),
        Name: filter.name,
        SearchAll: filter.searchAll,
      } 
    });
  }
  
  getContactById(id: number): Observable<Contact> {
    return this.httpClient.get<Contact>(this.controllerUrl + '/' + id);
  }

  createContact(contact: Contact): Observable<Contact> {
    return this.httpClient.post<Contact>(this.controllerUrl, contact);
  }
  
  updateContact(contact: Contact): Observable<Contact> {
    return this.httpClient.put<Contact>(this.controllerUrl, contact);
  }

  deleteContact(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.controllerUrl + '/' + id);
  }
}
